/**
 * Strips ANSI escape sequences from a string using a single-pass state machine.
 *
 * Handles CSI (Control Sequence Introducer), OSC (Operating System Command),
 * and single-character escape sequences. This is the same algorithm used by
 * the runtime in `src/terminal/output-utils.ts`, kept as a separate copy to
 * avoid pulling Node-only modules into the browser bundle.
 */
export function stripAnsi(input: string): string {
	let output = "";
	let mode: "text" | "escape" | "csi" | "osc" | "osc_escape" = "text";
	for (const char of input) {
		if (mode === "text") {
			if (char === "\u001b") {
				mode = "escape";
				continue;
			}
			output += char;
			continue;
		}
		if (mode === "escape") {
			if (char === "[") {
				mode = "csi";
				continue;
			}
			if (char === "]") {
				mode = "osc";
				continue;
			}
			mode = "text";
			continue;
		}
		if (mode === "csi") {
			const code = char.charCodeAt(0);
			if (code >= 64 && code <= 126) {
				mode = "text";
			}
			continue;
		}
		if (mode === "osc") {
			if (char === "\u0007") {
				mode = "text";
			} else if (char === "\u001b") {
				mode = "osc_escape";
			}
			continue;
		}
		if (mode === "osc_escape") {
			mode = char === "\\" ? "text" : "osc";
		}
	}
	return output;
}
